import React from 'react';
import HeroSectionHealthcare from '../components/HeroSectionHealthcare';
import LogoSection from '../components/LogoSection';
import StatsSectionHealthcare from '../components/StatsSectionHealthcare';
import TeamSection from '../components/TeamSection';
import TimelineSection from '../components/TimelineSection';
import FAQSection from '../components/FAQSection';
const HealthcareClinicsPage = () => {
  return <main className="flex-grow" data-id="element-226">
      <HeroSectionHealthcare data-id="element-227" />
      <LogoSection data-id="element-228" />
      <StatsSectionHealthcare data-id="element-229" />
      <TeamSection data-id="element-230" />
      <TimelineSection data-id="element-231" />
      <FAQSection data-id="element-232" />
    </main>;
};
export default HealthcareClinicsPage;